import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Client render (not hydration). Prerendered pages (scripts/prerender.js) ship
// real HTML + SEO tags for crawlers and social unfurlers, and give users a fast
// first paint; React then mounts a fresh, fully-interactive tree over identical
// content. We intentionally do NOT hydrate: this SPA's auth-aware nav, cookie
// banner, install prompt and entrance animations resolve via effects, so the
// prerendered snapshot never matches React's first render — hydration would
// throw recoverable mismatches on every page. A clean client render avoids that
// entire class of issues with no SEO cost.
ReactDOM.createRoot(container).render(tree);

// Register PWA service worker (production only — CRA dev breaks with SW)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
